<template>
  <div>
    <div style="width: 100%" class="form-control" :class="{ 'has-error': errors.has(name) }">
      <input
        v-if="!textarea"
        v-validate="{ required, email: email ? true : false }"
        :name="name"
        :type="type"
        :placeholder="placeholder"
        v-model="fakeValue"
        @keyup="updatecomma"
        class="depainput rsu mb-0"
      />

      <textarea
        v-else
        v-validate="{ required }"
        :name="name"
        :placeholder="placeholder"
        v-model="fakeValue"
        :type="type"
        class="depainput rsu mb-0"
        style="height: 101px !important"
      />
      <span class="text-error" v-if="errors.has(name)">{{ errors.first(name) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],

  props: {
    name: {
      type: String,
      default: '',
      required: true
    },
    value: {
      default: ''
    },
    checkcash: {
      default: false
    },
    required: {
      default: false
    },
    textarea: {
      default: false
    },
    placeholder: {
      default: '',
      type: String
    },
    email: {
      default: false
    },
    type: {
      default: 'text',
      type: String
    }
  },
  computed: {
    fakeValue: {
      get() {
        return this.value
      },
      set(e) {
        this.$emit('input', e)
      }
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e.target.value)
    },
    updatecomma(evt) {
      if (this.checkcash) {
        let x = this.fakeValue
        x = x.replace(/[,\s]+|[,\s]+/g, '')
        x = x.replace(/[^0-9.]/g, '')
        // console.log(x)
        var pattern = /\d{1,3}(?=(\d{3})+(?!\d))/g
        x = x.replace(pattern, '$&,')
        this.fakeValue = x
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/depainput.vue